import { useRef, useCallback, MutableRefObject } from "react";

import { isInputElementTypeGuard } from "src/utils";

export const useElementFocus = <T extends HTMLElement>(): [
  MutableRefObject<T | null>,
  () => void,
] => {
  const ref = useRef<T | null>(null);

  const setFocus = useCallback((): void => {
    const element = ref.current;

    if (!element) return;

    element.focus();

    if (!isInputElementTypeGuard(element)) return;

    const cursorEndPosition = element.value.length;

    element.setSelectionRange(cursorEndPosition, cursorEndPosition);
  }, []);

  return [ref, setFocus];
};
